import React, { useState } from "react";
import { Link } from "react-router-dom";

const SideBar = ({ items }) => {
  const [sideBarShown, setSideBarShown] = useState(false);

  const toggleSideBarVisiblity = () => {
    setSideBarShown(sideBarShown ? false : true);
  };

  return (
    <div className={`col-lg-3 sidebar-main ${sideBarShown ? "show" : "hide"}`}>
      <button className="sidebar-main-toggle" onClick={toggleSideBarVisiblity}>
        <div className={`hamburger ${sideBarShown ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </button>
      <div className="sidebar-main__content">
        <ul>
          {items.map((item) => (
            <li key={item?.id || item?.text} className={`${item?.active ? "active" : ""}`}>
              <Link to={item?.link}>
                {item?.icon}
                <p>{item?.text}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
